import getPrefix from '@/api/apiConfig.js'
const createRestUrls = () => {
  var restUrls
  if (process.env.NODE_ENV === 'production') {
    restUrls = {
      // url_3pl: 'http://3pl.glsc.jd.com/rest/placeOrder',
      url_3pl_async_label: '/placeOrderApi/rest/getLabelInfo',
      url_3pl: '/placeOrderApi/rest/placeOrder',
      url_3pl_new: '/repackageApi/waybill/repackage',
      url_printPlatform: '/printPlatformApi/doc/print',
      url_3pl_printPlatform_print_center:'/printCenterApi/globalPrint/print', //新增老打印接口直连打印中心
      url_3pl_platForm_new: '/printPlatformApi/doc/printAll',
      url_3pl_platForm_dangerous_package: '/printCenterApi/globalPrint/printAll',
      url_batchPrintPlatform: '/printPlatformApi/doc/hssDeShipListDataPrint',
      cloud_print_url: 'http://localhost:9021/v2/print/',
      logout_url: 'https://pulsar-login.jd.com/logout.html',
      select_spm_tenant_url: 'https://pulsar-login.jd.com/selectTenant',
      check_resource_url: `${getPrefix().mcsApi}/user/checkSpmResource`,
      check_spm_user_identity_url: `${getPrefix().mcsApi}/user/checkSpmUserIdentity`,
      query_menu_list_url: `${getPrefix().mcsApi}/user/queryMenuList`,
      query_spm_resource_list_url: `${getPrefix().mcsApi}/user/querySpmResourceList`,
      query_spm_warehouse_list_url: `${getPrefix().mcsApi}/user/querySpmWarehouseList`,
      query_warehouse_list_url: `${getPrefix().mcsApi}/user/queryWarehouseList`,
      select_warehouse_url: `${getPrefix().mcsApi}/user/selectWarehouse`,
      bind_user_url: `${getPrefix().mcsApi}/user/batchBindUser`,
      fop_print_url: '/servicebillApi/servicebill/updateOutstockPackage?LOP-DN=ifop.jd.com',
      cloud_print_base64_image: 'http://localhost:9021/v2/PrintImage',
      query_cloud_printer: 'http://localhost:9021/v2/printer',
      findAddress_byTracking_number: '/printCenterApi/globalPrint/findAddressByTrackingNumber',
      globalPrint_print: '/printCenterApi/globalPrint/print',
      gtc_print:'/doc-manager/queryOrderDocDetail',
      query_favorite_menu_list: `${getPrefix().mcsApi}/user/queryFavoriteMenuList`,
      add_favorite_menu: `${getPrefix().mcsApi}/user/addFavoriteMenu`,
      cancel_favorite_menu: `${getPrefix().mcsApi}/user/cancelFavoriteMenu`,
      modify_favorite_menu:`${getPrefix().mcsApi}/user/modifyFavoriteMenu`,
      importMovePlanStocks_url: `${getPrefix().outboundApi}/import/movePlanStocks3`,
      stockBacklog_url: `${getPrefix().taskWebApi}/stockBacklogController/getStockInfo`,
      submitLog_url: '/servicebillApi/addLog?LOP-DN=imp.gateway.api.jdl.com',
      progressBoard_url: `${getPrefix().reportApi}/export/progress/board`,
      queryPositionList: `${getPrefix().mcsApi}/user/getPositionSelector`,
      queryUserListByPage: `${getPrefix().mcsApi}/user/queryUserListByPage`,
      batchDeleteUser: `${getPrefix().mcsApi}/user/disableUserBatch`,
      queryUser: `${getPrefix().mcsApi}/user/queryUserRoleList`,
      bindUserRoleBatch: `${getPrefix().mcsApi}/user/bindUserRoleBatch`
    }
  }
  else if (process.env.NODE_ENV === 'pre') {
    restUrls = {
      // url_3pl: 'http://3pl.glsc.jd.com/rest/placeOrder',
      url_3pl_async_label: '/placeOrderApi/rest/getLabelInfo',
      url_3pl: '/placeOrderApi/rest/placeOrder',
      url_3pl_new: '/repackageApi/waybill/repackage',
      url_printPlatform: '/printPlatformApi/doc/print',
      url_3pl_printPlatform_print_center:'/printCenterApi/globalPrint/print', //新增老打印接口直连打印中心
      url_3pl_platForm_new: '/printPlatformApi/doc/printAll',
      url_3pl_platForm_dangerous_package: '/printCenterApi/globalPrint/printAll',
      url_batchPrintPlatform: '/printPlatformApi/doc/hssDeShipListDataPrint',
      cloud_print_url: 'http://localhost:9021/v2/print/',
      logout_url: 'https://pulsar-login.jd.com/logout.html',
      select_spm_tenant_url: 'https://pulsar-login.jd.com/selectTenant',
      check_resource_url: `${getPrefix().mcsApi}/user/checkSpmResource`,
      check_spm_user_identity_url: `${getPrefix().mcsApi}/user/checkSpmUserIdentity`,
      query_menu_list_url: `${getPrefix().mcsApi}/user/queryMenuList`,
      query_spm_resource_list_url: `${getPrefix().mcsApi}/user/querySpmResourceList`,
      query_spm_warehouse_list_url: `${getPrefix().mcsApi}/user/querySpmWarehouseList`,
      query_warehouse_list_url: `${getPrefix().mcsApi}/user/queryWarehouseList`,
      select_warehouse_url: `${getPrefix().mcsApi}/user/selectWarehouse`,
      bind_user_url: `${getPrefix().mcsApi}/user/batchBindUser`,
      fop_print_url: '/servicebillApi/servicebill/updateOutstockPackage?LOP-DN=ifop.jd.com',
      cloud_print_base64_image: 'http://localhost:9021/v2/PrintImage',
      query_cloud_printer: 'http://localhost:9021/v2/printer',
      findAddress_byTracking_number: '/printCenterApi/globalPrint/findAddressByTrackingNumber',
      globalPrint_print: '/printCenterApi/globalPrint/print',
      gtc_print:'/doc-manager/queryOrderDocDetail',
      query_favorite_menu_list: `${getPrefix().mcsApi}/user/queryFavoriteMenuList`,
      add_favorite_menu: `${getPrefix().mcsApi}/user/addFavoriteMenu`,
      cancel_favorite_menu: `${getPrefix().mcsApi}/user/cancelFavoriteMenu`,
      modify_favorite_menu:`${getPrefix().mcsApi}/user/modifyFavoriteMenu`,
      importMovePlanStocks_url: `${getPrefix().outboundApi}/import/movePlanStocks3`,
      stockBacklog_url: `${getPrefix().taskWebApi}/stockBacklogController/getStockInfo`,
      submitLog_url: '/servicebillApi/addLog?LOP-DN=imp.gateway.api.jdl.com',
      progressBoard_url: `${getPrefix().reportApi}/export/progress/board`,
      queryPositionList: `${getPrefix().mcsApi}/user/getPositionSelector`,
      queryUserListByPage: `${getPrefix().mcsApi}/user/queryUserListByPage`,
      batchDeleteUser: `${getPrefix().mcsApi}/user/disableUserBatch`,
      queryUser: `${getPrefix().mcsApi}/user/queryUserRoleList`,
      bindUserRoleBatch: `${getPrefix().mcsApi}/user/bindUserRoleBatch`
    }
  }
  else if (process.env.NODE_ENV === 'development') {
    restUrls = {
      url_3pl_async_label: '/placeOrderApi/rest/getLabelInfo',
      url_3pl: '/placeOrderApi/rest/placeOrder',
      url_3pl_new: '/repackageApi/waybill/repackage',
      url_printPlatform: '/printPlatformApi/doc/print',
      url_3pl_printPlatform_print_center:'/printCenterApi/globalPrint/print', //新增老打印接口直连打印中心
      url_3pl_platForm_new: '/printPlatformApi/doc/printAll',
      url_3pl_platForm_dangerous_package: '/printCenterApi/globalPrint/printAll',
      url_batchPrintPlatform: '/printPlatformApi/doc/hssDeShipListDataPrint',
      cloud_print_url: 'http://localhost:9021/v2/print/',
      logout_url: 'http://test-glsc-passport.jd.com/logout.html',
      select_spm_tenant_url: 'http://test-glsc-passport.jd.com/selectTenant',
      check_resource_url: `${getPrefix().mcsApi}/user/checkSpmResource`,
      check_spm_user_identity_url:`${getPrefix().mcsApi}/user/checkSpmUserIdentity`,
      query_menu_list_url: `${getPrefix().mcsApi}/user/queryMenuList`,
      query_spm_resource_list_url: `${getPrefix().mcsApi}/user/querySpmResourceList`,
      query_spm_warehouse_list_url: `${getPrefix().mcsApi}/user/querySpmWarehouseList`,
      query_warehouse_list_url: `${getPrefix().mcsApi}/user/queryWarehouseList`,
      select_warehouse_url: `${getPrefix().mcsApi}/user/selectWarehouse`,
      bind_user_url: `${getPrefix().mcsApi}/user/batchBindUser`,
      fop_print_url: '/servicebillApi/servicebill/updateOutstockPackage?LOP-DN=ifop.jd.com',
      cloud_print_base64_image: 'http://localhost:9021/v2/PrintImage',
      query_cloud_printer: 'http://localhost:9021/v2/printer',
      findAddress_byTracking_number: '/printCenterApi/globalPrint/findAddressByTrackingNumber',
      globalPrint_print: '/printCenterApi/globalPrint/print',
      gtc_print:'/doc-manager/queryOrderDocDetail',
      query_favorite_menu_list: `${getPrefix().mcsApi}/user/queryFavoriteMenuList`,
      add_favorite_menu: `${getPrefix().mcsApi}/user/addFavoriteMenu`,
      cancel_favorite_menu: `${getPrefix().mcsApi}/user/cancelFavoriteMenu`,
      modify_favorite_menu:`${getPrefix().mcsApi}/user/modifyFavoriteMenu`,
      importMovePlanStocks_url: `${getPrefix().outboundApi}/import/movePlanStocks3`,
      stockBacklog_url: `${getPrefix().taskWebApi}/stockBacklogController/getStockInfo`,
      submitLog_url: '/servicebillApi/addLog?LOP-DN=imp.gateway.api.jdl.com',
      progressBoard_url: `${getPrefix().reportApi}/export/progress/board`,
      queryPositionList: `${getPrefix().mcsApi}/user/getPositionSelector`,
      queryUserListByPage: `${getPrefix().mcsApi}/user/queryUserListByPage`,
      batchDeleteUser: `${getPrefix().mcsApi}/user/disableUserBatch`,
      queryUser: `${getPrefix().mcsApi}/user/queryUserRoleList`,
      bindUserRoleBatch: `${getPrefix().mcsApi}/user/bindUserRoleBatch`
    }
  }
  return restUrls;
}

export const restUrls = createRestUrls();
